export const DISCONNECTED = "disconnected";
export const MANUALLY_DISCONNECTED = "manually_disconnected";
export const CONNECTING = "connecting";
export const CONNECTED = "connected";
export const DISCONNECTING = "disconnecting";
